module.exports = __webpack_public_path__ + "static/media/level-down.ab0edb5a.svg";